import { useOutletContext } from "react-router-dom";

import ProductionsCalendarView from "../views/ProductionsCalendarView/ProductionsCalendarView";

export default function ProductionsCalendar() {
	const { data, organization } = useOutletContext();

	return <ProductionsCalendarView data={data} organization={organization} />;
}
